<template>
    <div>
        <h2>トップページ</h2>

        <v-col class="d-flex" cols="12" sm="4">
            <v-menu v-model="menu" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="string_select_month" label="月" readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="string_select_month" type="month" @input="selectMonth()"></v-date-picker>
            </v-menu>
        </v-col>

        <h3>{{ select_month }}月の買取一覧</h3>
        <v-data-table
            :headers="entry_headers"
            :items="entries"
            class="elevation-1"
            no-data-text="データはありません"
        >
        </v-data-table>
        <div>合計金額 {{ entries_sum_price }} 円</div>
        
        <h3>{{ select_month }}月の出庫一覧</h3>
        <v-data-table
            :headers="exit_headers"
            :items="exits"
            class="elevation-1"
            no-data-text="データはありません"
        >
        </v-data-table>
        <div>合計金額 {{ exits_sum_price }} 円</div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            menu: false,
            string_select_month: '',
            select_month: null,
            entries_sum_price: 0,
            exits_sum_price: 0,
            entries: [],
            exits: [],
            entry_headers: [
                { text: 'カード名', value: 'card.card_name' },
                { text: '色', value: 'card.color' },
                { text: '収録弾', value: 'card.lot' },
                { text: '買取日', value: 'buy_date' },
                { text: '買取方法', value: 'buy_method' },
                { text: 'カードの状態', value: 'condition' },
                { text: '金額(円)', value: 'buy_price' },
                { text: '数量', value: 'entry_quantity' },
            ],
            exit_headers: [
                { text: 'カード名', value: 'entry_source.card.card_name' },
                { text: '色', value: 'entry_source.card.color' },
                { text: '収録弾', value: 'entry_source.card.lot' },
                { text: 'カードの状態', value: 'entry_source.condition' },
                { text: '出庫日', value: 'sell_date' },
                { text: '出庫先', value: 'sell_destination' },
                { text: '金額(円)', value: 'sell_price' },
                { text: '数量', value: 'exit_quantity' },
            ],
        }
    },
    methods: {
        selectMonth() {
            this.menu = false
            this.entries_sum_price = 0
            this.exits_sum_price = 0
            const select_year_month = this.string_select_month

            if(this.string_select_month.startsWith('0', 5)) {
                this.select_month = Number(this.string_select_month.slice(-1))
            } else {
                this.select_month = Number(this.string_select_month.slice(-2))
            }

            this.axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/entry/search`, {
                params: {
                    account_id: this.$store.getters.getStoreId,
                    by_month: select_year_month
                }
            })
            .then(res => {
                this.entries = res.data
                for(var i=0; i<this.entries.length; i++) {
                    this.entries_sum_price += this.entries[i].total_price
                }
            })
            .catch(() => {
                alert(e)
            })

            this.axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/exit/search`, {
                params: {
                    account_id: this.$store.getters.getStoreId,
                    by_month: select_year_month
                }
            })
            .then(res => {
                this.exits = res.data
                for(var i=0; i<this.exits.length; i++) {
                    this.exits_sum_price += this.exits[i].total_price
                }
            })
            .catch(() => {
                alert(e)
            })


        }
    },
    mounted: function () {
        const today = new Date();
        var now_year = today.getFullYear()
        var now_month = today.getMonth() + 1
        this.select_month = now_month
        if(now_month < 10) now_month = "0" + now_month
        const now_year_month = now_year + "-" + now_month

        this.axios
        .get(`${process.env.VUE_APP_API_ORIGIN}/entry/search`, {
            params: {
                account_id: this.$store.getters.getStoreId,
                by_month: now_year_month
            }
        })
        .then(res => {
            this.entries = res.data
            for(var i=0; i<this.entries.length; i++) {
                this.entries_sum_price += this.entries[i].total_price
            }
        })
        .catch(() => {
            alert(e)
        })

        this.axios
        .get(`${process.env.VUE_APP_API_ORIGIN}/exit/search`, {
            params: {
                account_id: this.$store.getters.getStoreId,
                by_month: now_year_month
            }
        })
        .then(res => {
            this.exits = res.data
            for(var i=0; i<this.exits.length; i++) {
                this.exits_sum_price += this.exits[i].total_price
            }
        })
        .catch(() => {
            alert(e)
        })
    }
}
</script>
